<template>
  <plan-card>
    <div
      v-if="isSplitFunding"
      class="split-scale"
    >
      <div>
        <h3>Allocation Percentage Breakdown</h3>
      </div>

      <table>
        <tr>
          <td class="allocation-label">{{ formatPercent(selected.client.allocation.weight) }} Company Allocation</td>
          <td class="allocation-bar-wrapper">
            <div
              class="allocation-bar"
              :style="{width: formatPercent(selected.client.allocation.weight)}"
            />
          </td>
        </tr>
        <tr
          v-for="unit, index in orgUnits"
          :key="unit.id"
        >
          <td class="allocation-label">{{ formatPercent(unit.allocation.weight) }} {{ unit.label }} Allocation</td>
          <td class="allocation-bar-wrapper">
            <div
              class="allocation-bar"
              :style="{width: formatPercent(unit.allocation.weight), opacity: allocationOpacity[index]}"
            />
          </td>
        </tr>
        <tr v-if="employee.performance.mode === 'as-component'">
          <td class="allocation-label">
            {{ formatPercent(employee.allocation.weight) }} Individual Allocation
          </td>
          <td class="allocation-bar-wrapper">
            <div
              class="allocation-bar"
              :style="{width: formatPercent(employee.allocation.weight), opacity: allocationOpacity[allocationOpacity.length - 1]}"
            />
          </td>
        </tr>
        <tr>
          <td class="allocation-label">Total</td>
          <td class="allocation-bar-wrapper">
            <div
              class="allocation-total"
              :style="{width: formatPercent(selected.client.allocation.weight)}"
            />
            <div
              v-for="unit, index in orgUnits"
              :key="'unit-' + index"
              class="allocation-total"
              :style="{width: formatPercent(unit.allocation.weight), opacity: allocationOpacity[index]}"
            />
            <div
              v-if="employee.performance.mode == 'as-component'"
              class="allocation-total"
              :style="{width: formatPercent(employee.allocation.weight), opacity: allocationOpacity[allocationOpacity.length - 1]}"
            />
          </td>
        </tr>
      </table>
    </div>
    <forecast-scale
      v-else
      :tiers="selected.tiers"
      :forecast="selected.forecast"
      :client="selected.client"
      :distributions="selected.distributions"
      :is-eos="selected.plan.isEos"
      :organization="selected.organization"
    />
  </plan-card>
</template>

<script>
import PlanCard from "@/components/plans/global/PlanCard.vue";
import ForecastScale from "@/components/plans/short-term/scale/ForecastScale.vue";
import VLpercent from '@/composables/VLpercent';

export default {
  name: "PlanScale",

  components: {
    PlanCard,
    ForecastScale,
  },

  mixins: [],

  props: {
    selected: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {}
  },

  computed: {
    isSplitFunding() {
      return this.selected?.plan?.funding_mode === 'split';
    },

    orgUnits() {
      return Object.values(this.selected.organization.units);
    },

    employee() {
      return this.selected.employee;
    },

    allocationOpacity() {
      if (!this.isSplitFunding) return;
      let minOpacity = 30;
      let maxOpacity = 70;
      let stepCount = (this.orgUnits.length + (this.employee.performance.mode == 'as-component' ? 1 : 0))
      let opacityStep = (maxOpacity - minOpacity) / (stepCount > 1 ? stepCount - 1 : stepCount);
      let aReturn = [];
      for (let i = 0; i < stepCount; i++) {
        aReturn.push(maxOpacity - (opacityStep * i) + '%');
      }
      return aReturn;
    }
  },

  mounted() {},

  created() {},

  methods: {
    formatPercent(value, decimals = 0) {
        return VLpercent.formatPercent(value, decimals);
    }
  },
}
</script>

<style lang="scss" scoped>
@use "../../../../scss/_variables.scss";

.company-details {
  border-top: thin solid variables.$color-card-border;
}

.split-scale {
  width:100%;
  padding: 1rem 2rem;
}

.allocation-bar-wrapper {
  width: 100%;
}

.allocation-label {
  vertical-align: middle;
}

.allocation-bar {
  background-color: var(--brand-color);

  height: 50px;

  border-top-right-radius: 0.1875em;
  border-bottom-right-radius: 0.1875em;
}

.allocation-total {
  background-color: var(--brand-color);
  display: inline-block;
  height: 50px;

  &:last-of-type {
    border-top-right-radius: 0.1875em;
    border-bottom-right-radius: 0.1875em;
  }
}

td {
  padding: 8px;
}

table {
  width: 100%;
}

@media screen and (max-width: 500px) {
  tr {
    display: flex;
    flex-direction: column;
    width: auto;
  }
  
}
</style>